export default defineNuxtRouteMiddleware(async () => {
  const { user } = useUserSession()

  if (!user.value?.isOfficer)
    return createError({
      statusCode: 404,
      statusMessage: 'La página a la que intenta acceder no existe.',
    })
})
